import { Signal } from "signals";
import { HomeCommand } from "slotworks/commands/betbar/home-command";
import { MaxBetMessageCommand } from "slotworks/commands/betbar/max-bet-message-command";
import { HideAllMenusCommand } from "slotworks/commands/menus/hide-all-menus-command";
import { ShowAllMenusCommand } from "slotworks/commands/menus/show-all-menus-command";
import { FindValidTotalStake } from "slotworks/components/betbar/betbar-helpers";
import BetSection from "slotworks/components/betbar/menus/bet-section";
import BetOptions from "slotworks/components/betbar/vo/bet-options";
import Components from "slotworks/components/components";
import SoundToggleComponent from "slotworks/components/sound/sound-toggle-component";
import StepperComponent from "slotworks/components/ui/stepper-component";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import Currency from "slotworks/i18n/currency";
import { formatMoney } from "slotworks/utils/string-formatters";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import Translations from "slotworks/i18n/translations";
import BetModel from "slotworks/model/bets/bet-model";
import { FunctionBind } from "lodash";

export default class HelpPopup {
    private static BUTTON_CLOSE: string = "btn-close";
    
    private closeButton: FlexiButton;
    
    constructor() {
        this.close = this.close.bind(this);
    }

    private setupListeners() {
        this.closeButton = Layers.PromoPopups.getFlexiButton(HelpPopup.BUTTON_CLOSE);
        this.closeButton.setEnabled(true);
        this.closeButton.on(ButtonEvent.POINTER_UP,this.close);
    }

    public show() {
        Layers.PromoPopups.setScene("promohelp").execute();
        this.setupListeners();
        Layers.PromoPopups.show();
    }

    public close() {
        this.hide();
    }
    
    public hide() {
        this.closeButton.off(ButtonEvent.POINTER_UP,this.close);
        this.closeButton.setEnabled(false);
        Layers.PromoPopups.hide();
        Layers.PromoPopups.defaultScene().execute();
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/components/promo-popups/help-popup.ts